import { SupportModal } from 'shared/common/Header/components/SupportModal/Desktop'
import { clsx } from 'shared/libs/style-merge'

import { useDisclosure } from 'shared/hooks/useDisclosure'

import styles from './Support.module.scss'

interface SupportProps {
  label: string
  className?: string
}

export function Support({ label, className }: SupportProps) {
  const { isOpen, onClose, onOpen } = useDisclosure()

  return (
    <>
      <button className={clsx(styles.links, className)} onClick={onOpen}>
        {label}
      </button>
      <SupportModal isOpen={isOpen} onClose={onClose} />
    </>
  )
}
